import api from './api';

export const newsCategoryService = {
    create: (data) => api.post('/newscategory', data),
    getAll: (params) => api.get('/newscategory', { params }),
    update: (id, data) => api.put(`/newscategory/${id}`, data),
    delete: (id) => api.delete(`/newscategory/${id}`),
};
